import { render } from "./index.vue?vue&type=template&id=6f560c90"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/data-table-services/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f560c90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f560c90', __exports__)) {
    api.reload('6f560c90', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6f560c90", () => {
    api.rerender('6f560c90', render)
  })

}


export default __exports__